import { apiCallStatus, ASSET_TYPES, NEWCAPABILITIES } from 'helpers/constants';
import { translate } from 'helpers/translateHelper';
import { getInitialStartDate, getInitialEndDate } from 'sharedComponents/TimeSelectorRow/helpers';
import { sensorTypes } from './constants';


export const updateReportDownloadProgress = (reportList, reportID, loadingStatus) => {
    return reportList.map(report => {
        if (report.reportId === reportID) {
            if (loadingStatus === apiCallStatus.LOADING) {
                report.downloadInProgress = true;
            } else if (loadingStatus === apiCallStatus.SUCCESS || loadingStatus === apiCallStatus.ERROR) {
                report.downloadInProgress = false;
            }
        }
        return report;
    });
};

const getAssetTypeLabel = (assetTypeId) => {
    const getAssetTypeFromID = (value) => Object.keys(ASSET_TYPES).find(key => ASSET_TYPES[key] === value);
    const assetTypeName = getAssetTypeFromID(assetTypeId);
    return assetTypeName ? translate(`ABB.Powertrain.Frontend.${assetTypeName.toLowerCase()}Label`) : '-';
};

// eslint-disable-next-line import/no-unused-modules
export const hasDeleteCapability = (capabilities, neededCapability) => {
    let hasCapability = false;
    if (capabilities?.assetCapabilitiesInfos?.length) {
        for (const assetCapabilities of capabilities.assetCapabilitiesInfos) {
            for (const capabilityInfo of assetCapabilities.capabilityInfos) {
                if (capabilityInfo?.capabilityCode === neededCapability && capabilityInfo?.isAvailable) {
                    hasCapability = true;
                    break;
                }
            }
        }
    }
    return hasCapability;
};

// eslint-disable-next-line import/no-unused-modules
export const hasDeleteFleetCapability = (capabilities, neededCapability) => {
    let hasCapability = false;
    if (capabilities?.assetCapabilitiesInfos?.length) {
        for (const assetCapabilities of capabilities.assetCapabilitiesInfos) {
            for (const capabilityInfo of assetCapabilities.capabilityInfos) {
                if (capabilityInfo?.capabilityCode === neededCapability && capabilityInfo?.isAvailable) {
                    hasCapability = true;
                    break;
                }
            }
        }
    }
    return hasCapability;
};

// Helper function to find the asset capabilities for a specific asset ID
const findAssetCapabilities = (assetCapabilitiesInfos, assetId) => {
    return assetCapabilitiesInfos?.find(assetCapabilities => assetCapabilities?.assetId === assetId);
};

// Helper function to check if the needed capability is available
const checkCapabilityAvailability = (capabilityInfos, neededCapability) => {
    return capabilityInfos?.some(
        capabilityInfo =>
            capabilityInfo?.capabilityCode === neededCapability && capabilityInfo?.isAvailable
    );
};

export const hasCapability = (assetId, capabilities, neededCapability) => {
    if (!capabilities?.assetCapabilitiesInfos?.length) {
        return false;
    }

    const assetCapabilities = findAssetCapabilities(capabilities?.assetCapabilitiesInfos, assetId);
    if (!assetCapabilities) {
        return false;
    }
    return checkCapabilityAvailability(assetCapabilities?.capabilityInfos, neededCapability);
};

export const isSensorTypeMSR = (asset, sensorOfAssets) => {
    let isMatching = false;

    if (sensorOfAssets) {
        for (const sensorInfo of sensorOfAssets) {
            if (asset.id === sensorInfo.assetId && sensorInfo.sensorType === sensorTypes.MSR) {
                isMatching = true;
                break;
            }
        }
    }
    return isMatching;
};

export const mapReports = (reportList, capabilities) => {
    return reportList?.map(report => {
        report.reportTypeName = translate(report.reportType?.reportTypeTranslationCode) || report.reportType?.reportTypeDisplayName;
        report.reportStatusName = translate(`ABB.Powertrain.Frontend.reportsStatus${report.reportStateId}`);
        report.downloadInProgress = false;
        report.assetTypeName = getAssetTypeLabel(report.reportType?.assetTypeId);
        report.canDelete = hasDeleteCapability(capabilities, NEWCAPABILITIES.deleteReport);
        report.canFleetDelete = hasDeleteFleetCapability(capabilities, NEWCAPABILITIES.fleetOverviewReportDelete);
        return report;
    });
};

export const getPreselectedDates = (daysBack = 7) => ({
    from: getInitialStartDate(daysBack),
    to: getInitialEndDate(daysBack)
});
